'use strict';

/*global BasicBarcodes*/
/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global sprintf*/
/*global resSuccess*/

function BarcodesDeliveryNotes(containerId) {
  this.isEnabledCheckJoinedDeliveryNotes = true;

  BasicBarcodes.call(this, containerId);
}

BarcodesDeliveryNotes.prototype = $.extend({}, BasicBarcodes.prototype, {
  constructor: 'BarcodesDeliveryNotes',

  //----------------------------------------------------------------------------

  addJoinedDeliveryNotes: function addJoinedDeliveryNotes(RID) {
    var _this = this;

    blockElement(_this.$container);
    services.get('consolidation-service').getJoinedDeliveryNotes(RID, function (data) {
      unBlockElement(_this.$container);

      if (!data.length) {
        return;
      }

      app.confirmHtml(sprintf(app.t('consolidation.loaded_joined_delivery_notes'), data.length), function (ret) {
        if (!ret) {
          return;
        }

        _this.isEnabledOnAfterAddItem = false;
        try {
          $.each(data, function (key, item) {
            var $row = _this.addItem(item.Barcode);

            _this.updateItemByData($row, item);
          });
        } finally {
          _this.isEnabledOnAfterAddItem = true;
        }
      });
    });

    return _this;
  },

  updateItemByData: function updateItemByData($row, data) {
    var _this = this;

    $row.find('input[name$="[RID]"]').val(data.RID);
    $row.find('.barcodes-items__barcode-description').text(data.DocumentIdentification);

    return _this;
  },

  onAfterAddItem: function onAfterAddItem($row) {
    var _this = this;

    var barcode = $row.find('input[name$="[Barcode]"]').val();

    blockElement(_this.$container);
    services.get('delivery-note-service').findDeliveryNote(barcode, function (res, resData) {
      unBlockElement(_this.$container);

      if (res !== resSuccess) {
        return _this.removeItem($row);
      }

      //aktualizujeme aktualni radek
      _this.updateItemByData($row, resData);

      //zkusime dohledat dalsi dodaci listy
      if (_this.isEnabledCheckJoinedDeliveryNotes) {
        _this.addJoinedDeliveryNotes(resData.RID);
        _this.isEnabledCheckJoinedDeliveryNotes = false;
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

});
